import { render, staticRenderFns } from "./for-game-type-select-input.vue?vue&type=template&id=04b25a70&"
import script from "./for-game-type-select-input.vue?vue&type=script&lang=js&"
export * from "./for-game-type-select-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports